import { render, staticRenderFns } from "./instructorDetails.vue?vue&type=template&id=6bdeb682"
import script from "./instructorDetails.vue?vue&type=script&lang=js"
export * from "./instructorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports